import * as React from 'react';
import { styled } from '@mui/material/styles';
import { IUserReadResourceV12 } from 'components/order/model/Order';
import { addOpacity } from './helpers';

const UserAvatarImg = styled('img')(({ theme }) => ({
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    marginRight: theme.spacing(0.5)
}));

const UserAvatarInitials = styled('span')(({ theme }) => ({
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    marginRight: theme.spacing(0.5),
    fontSize: theme.spacing(2),
    color: theme.palette.common.black,
    border: `1px solid ${addOpacity(theme.palette.common.black, 0.6)}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
}));

interface IProps {
    user?: IUserReadResourceV12 | undefined;
    classNames?: string;
}

export const UserAvatar: React.FC<React.PropsWithChildren<IProps>> = ({ user, classNames }) => {
    const [isAvatarAvailable, setIsAvatarAvailable] = React.useState<boolean>(true);
    const handleError = React.useCallback(() => {
        setIsAvatarAvailable(false);
    }, []);
    const userInitials = React.useMemo(() => {
        const firstLetter = user?.firstName ? user?.firstName[0] : '';
        const secondLetter = user?.lastName ? user?.lastName[0] : '';
        return user ? firstLetter + secondLetter : '';
    }, [user]);

    return user && isAvatarAvailable ? (
        <UserAvatarImg
            className={classNames}
            src={`${process.env.MEDIA_URL}/users/avatars/${user.userId}.jpg`}
            onError={handleError}
        />
    ) : (
        <UserAvatarInitials className={classNames}>{userInitials}</UserAvatarInitials>
    );
};
